import {
  IconAnalytics,
  IconBell,
  IconBinocularsGray,
  IconCar,
  IconCctvLine,
  IconChainLink,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';
import subVideo1 from '@src/assets/images/solution/constructionSafety/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/constructionSafety/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/constructionSafety/video/sub/rtlsVideo3.mp4';
import subVideo4 from '@src/assets/images/solution/constructionSafety/video/sub/rtlsVideo4.mp4';
import subVideo5 from '@src/assets/images/solution/constructionSafety/video/sub/rtlsVideo5.mp4';

import image1 from '@src/assets/images/solution/constructionSafety/img/1.avif';
import image2 from '@src/assets/images/solution/constructionSafety/img/2.avif';
import image3 from '@src/assets/images/solution/constructionSafety/img/3.avif';
import image4 from '@src/assets/images/solution/constructionSafety/img/4.avif';

export default {
  type: 'Giải pháp xây dựng',
  banner: {
    title: 'Phát hiện và xử lý ngay rủi ro của công nhân tại công trường.',
    desc: 'Giám sát vị trí công nhân theo thời gian thực và phản ứng ngay khi xảy ra tình huống nguy hiểm, tăng cường an toàn cho công trường.',
  },

  video: {
    title: 'Tối ưu quản lý an toàn công trường với dữ liệu vị trí theo thời gian thực.',
    desc: 'Theo dõi chính xác vị trí của công nhân tại công trường theo thời gian thực, phát hiện rủi ro từ sớm và xử lý nhanh chóng, nâng cao an toàn và hiệu quả vận hành.',
    play: mainVideo,
  },

  func: [
    {
      theme: 'Giám sát vị trí công nhân theo thời gian thực, giảm thiểu nguy cơ tai nạn.',
      title: 'Theo dõi vị trí công nhân theo thời gian thực',
      desc: 'Theo dõi vị trí hiện tại của công nhân với độ chính xác ±50cm, phát hiện ngay các rủi ro tiềm ẩn trong công trường và đưa ra biện pháp xử lý kịp thời.',
      sub1: 'Độ chính xác cao',
      icon1: IconRulerGray,
      sub2: 'Theo dõi trạng thái theo thời gian thực',
      icon2: IconClockGray,
      video: subVideo1,
    },
    {
      title: 'Cảnh báo tự động khi vào khu vực nguy hiểm',
      desc: 'Khi công nhân tiếp cận hoặc đi vào khu vực nguy hiểm đã được chỉ định, quản lý sẽ nhận được cảnh báo ngay lập tức, đảm bảo an toàn và ngăn ngừa tai nạn.',
      sub1: 'Theo dõi vị trí theo thời gian thực',
      icon1: IconBinocularsGray,
      sub2: 'Liên kết dữ liệu nhanh',
      icon2: IconTvocGray,
      video: subVideo2,
    },
    {
      title: 'Quản lý đồng thời vị trí thiết bị hạng nặng',
      desc: 'Gắn thẻ định vị cho thiết bị hạng nặng để quản lý tuyến di chuyển và vị trí hiện tại, đồng bộ với thông tin vị trí công nhân. Giúp giảm thiểu nguy cơ va chạm và nâng cao hiệu quả vận hành thiết bị.',
      sub1: 'Theo dõi vị trí theo thời gian thực',
      icon1: IconBinocularsGray,
      sub2: 'Độ chính xác cao',
      icon2: IconRulerGray,
      video: subVideo3,
    },
    {
      title: 'Ghi lại lộ trình di chuyển và phòng ngừa tai nạn',
      desc: 'Ghi lại lộ trình di chuyển của công nhân để phản ứng nhanh khi xảy ra sự cố. Phân tích trước các tuyến đường nguy hiểm để xây dựng kế hoạch quản lý an toàn hiệu quả.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu trên đám mây',
      icon2: IconCloudCheckGray,
      video: subVideo4,
    },
    {
      theme: 'Lưu lại dữ liệu an toàn, bắt đầu quản lý vận hành hiệu quả hơn',
      title: 'Giám sát an toàn kết hợp CCTV',
      desc: 'Liên kết dữ liệu vị trí công nhân với hình ảnh CCTV của công trường theo thời gian thực, trực quan hóa tình hình thực tế. Khi có sự cố, nhanh chóng kiểm tra vị trí và khu vực xung quanh công nhân qua video để xử lý chính xác.',
      sub1: 'Cài đặt khu vực linh hoạt',
      icon1: IconZoneGray,
      sub2: 'Thiết lập nhiều khu vực',
      icon2: IconTagGray,
      image: image1,
    },
    {
      title: 'Tự động tạo báo cáo quản lý an toàn',
      desc: 'Báo cáo quản lý an toàn được tự động tạo hàng ngày hoặc hàng tuần và gửi đến quản lý. Thông tin sự cố và biện pháp phòng ngừa được sắp xếp có hệ thống, hỗ trợ quản lý hiệu quả.',
      sub1: 'Cài đặt khu vực linh hoạt',
      icon1: IconZoneGray,
      sub2: 'Thiết lập nhiều khu vực',
      icon2: IconTagGray,
      image: image2,
    },
    {
      title: 'Phân tích dữ liệu lịch sử sự cố nguy hiểm',
      desc: 'Phân tích dữ liệu di chuyển của công nhân và sự cố nguy hiểm trong quá khứ để xác định rõ các khu vực và tình huống thường xảy ra tai nạn. Dựa trên đó xây dựng kế hoạch quản lý an toàn hiệu quả hơn.',
      sub1: 'Cài đặt khu vực linh hoạt',
      icon1: IconZoneGray,
      sub2: 'Thiết lập nhiều khu vực',
      icon2: IconTagGray,
      image: image3,
    },
    {
      title: 'Hỗ trợ tối ưu hóa bố trí nhân sự',
      desc: 'Phân tích mật độ công nhân và dữ liệu di chuyển để tối ưu bố trí nhân sự tại công trường, quản lý hiệu quả và giảm chi phí vận hành.',
      sub1: 'Cài đặt khu vực linh hoạt',
      icon1: IconZoneGray,
      sub2: 'Thiết lập nhiều khu vực',
      icon2: IconTagGray,
      image: image4,
    },
  ],

  subfunc: {
    title: 'Tóm tắt chức năng chính',
    desc: '',

    data: [
      {
        icon: IconLocation,
        title: 'Theo dõi vị trí công nhân theo thời gian thực',
        desc: 'Theo dõi vị trí công nhân với độ chính xác ±50cm theo thời gian thực.',
      },
      {
        icon: IconWarning,
        title: 'Cảnh báo tự động khi vào khu vực nguy hiểm',
        desc: 'Khi công nhân vào khu vực nguy hiểm, hệ thống sẽ ngay lập tức gửi cảnh báo cho quản lý.',
      },
      {
        icon: IconCar,
        title: 'Giám sát đồng thời vị trí thiết bị hạng nặng',
        desc: 'Quản lý đồng thời vị trí thiết bị hạng nặng và công nhân để tránh rủi ro va chạm.',
      },
      {
        icon: IconRoute,
        title: 'Ghi lại lộ trình di chuyển công nhân',
        desc: 'Tự động ghi lại lộ trình di chuyển để hỗ trợ phòng ngừa rủi ro và xử lý nhanh khi xảy ra sự cố.',
      },
      {
        icon: IconCctvLine,
        title: 'Hỗ trợ liên kết CCTV',
        desc: 'Liên kết vị trí công nhân với hình ảnh CCTV để giám sát tình hình thực tế theo thời gian thực.',
      },
      {
        icon: IconChartBar,
        title: 'Tạo báo cáo quản lý an toàn',
        desc: 'Phân tích dữ liệu an toàn và sự cố để tự động tạo báo cáo.',
      },
      {
        icon: IconSearch,
        title: 'Quản lý mật độ công nhân',
        desc: 'Giám sát mật độ công nhân theo thời gian thực và cảnh báo khi vượt ngưỡng.',
      },
      {
        icon: IconLayers,
        title: 'Hỗ trợ tối ưu hóa bố trí nhân sự',
        desc: 'Phân tích mật độ công nhân để bố trí nhân sự một cách hợp lý và hiệu quả.',
      },
      {
        icon: IconAnalytics,
        title: 'Phân tích dữ liệu sự cố nguy hiểm',
        desc: 'Phân tích dữ liệu sự cố trong quá khứ để xây dựng kế hoạch phòng ngừa tai nạn.',
      },
      {
        icon: IconSecurity,
        title: 'Hỗ trợ kiểm tra và tuân thủ an toàn',
        desc: 'Sử dụng dữ liệu vị trí và lộ trình của công nhân làm tài liệu kiểm tra và tuân thủ quy định.',
      },
    ],
  },

  system: {
    title: 'Cấu trúc hệ thống',
    img: rtlsSystem,
  },

  productTitle: 'Gói sản phẩm',
  product: [
    {
      tag: 'workerPackage',
    },
    {
      tag: 'assetPackage',
    },
  ],

  contents: [
    {
      data: 'constructionAsset',
    },
    {
      data: 'constructionEquipment',
    },
    {
      data: 'blogRTLS',
    },
    {
      data: 'blogMedical',
    },
  ],
};
